module.exports = __webpack_public_path__ + "img/thian-leng-logo.71697424.svg";